import MaterialTable from "@material-table/core";

const OrderTable = (props) => {
  const { tableData } = props;

  const columns = [
    {
      title: "From Location",
      field: "pickupLocation",
      hidden: false,
      sorting: true,
      headerStyle: {
        fontSize: "12px",
        fontWeight: "bold",
      },
    },
    {
      title: "To Location",
      field: "destination",
      hidden: false,
      sorting: false,
      headerStyle: {
        fontSize: "12px",
        fontWeight: "bold",
      },
    },
    {
      title: "Product",
      field: "product",
      hidden: false,
      sorting: true,
      headerStyle: {
        fontSize: "12px",
        fontWeight: "bold",
      },
    },
  ];
  return (
    <MaterialTable
      columns={columns}
      localization={{
        body: {
          emptyDataSourceMessage: (
            <h6 className="left-[45%] absolute top-[40%] text-center">
              No records to display
            </h6>
          ),
        },
      }}
      options={{
        rowStyle: {
          fontSize: 14,
          background: "white",
        },
        selection: false,
        search: false,
        showTitle: false,
        grouping: false,
        pageSize: 100,
        filtering: false,
        paging: false,
        toolbar: false,
        maxBodyHeight: 172,
        headerStyle: {
          backgroundColor: "#FFFFFF",
          fontWeight: "400",
          color: "black",
          position: "sticky", // Make header sticky
          top: 0, // Stick to top
          zIndex: 10,
        },
        draggable: false,
        // pageSizeOptions: [100, 500, 1000],
        actionsColumnIndex: -1,
        filterCellStyle: {
          flex: 1,
        },
      }}
      title={"New Quotes"}
      data={tableData}
      style={{ boxShadow: "none", textAlign: "left" }}
    />
  );
};

export default OrderTable;
